module.exports = __webpack_public_path__ + "bf8eb5c3ba56053bd7acf31e7eb7b4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/J@2x.png
// module id = 825
// module chunks = 0